import PlanMain from '../components/plan/Main.vue'
import Create from '../components/plan/Create.vue'
import ModelPort from '../components/plan/ModelPort.vue'
import ModelPortPlus from '../components/plan/ModelPortPlus.vue'

const routerPlan = {
    path: '/plan',
    name: 'plan',
    component: PlanMain,
    props: true,
    children: [
      {
        path: 'modelport',
        name: 'modelport',
        component: ModelPort,
        props: true,
      },
      {
        path: 'modelport-plus',
        name: 'modelportplus',
        component: ModelPortPlus,
        props: true,
      },
      {
        path: 'create',
        name: 'create',
        component: Create,
        props: true,
      },
    ]
  }

export default routerPlan
